import { Routes } from '@angular/router';
import { ObjectDetectionComponent } from './object-detection.component';

export const RECOGNITION_ROUTES: Routes = [
  { path: 'image-recognition', component: ObjectDetectionComponent },
  { path: 'image-recognition/:format', component: ObjectDetectionComponent },
];
